import { acceptHMRUpdate, defineStore } from 'pinia';

export const useGisEditorStore = defineStore('gisEditor', {
  state: () => ({
    1: 0,
    centroide: null,
    currentGeoFeature: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Polygon',
            coordinates: [],
          },
        },
      ],
    },
    featureInfoSigpac: {},
    sigpacMap: '',
  }),

  actions: {
    setLocation({ area, centroide }) {
      this.area = area;
      this.centroide = centroide;
      this.currentGeoFeature = {
        type: 'FeatureCollection',
        features: this.featureInfoSigpac.features,
      };
    },

    resetAll() {
      this.currentGeoFeature = null;
      this.area = 0;
      this.centroide = null;
      this.featureInfoSigpac = null;
    },

    async fetchFeatureInfoSigpac(url) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        await fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            this.featureInfoSigpac = result;
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },

    async fetchSigpacMap(url) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        await fetch(url, requestOptions)
          .then((response) => {
            this.sigpacMap = response;
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },
  },

  getters: {
    viewCentroide() {
      if (this.centroide === null) {
        return {
          lat: 0,
          lng: 0,
        };
      }

      return this.centroide;
    },
  },

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useGisEditorStore, import.meta.webpackHot));
}
